import { render, staticRenderFns } from "./DocumentsItem.vue?vue&type=template&id=6f330b22&"
import script from "./DocumentsItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports